module.exports = __webpack_public_path__ + "img/logo.af73627b.svg";